const SmartPhone = ({ className }) => {
  return (
    <svg
      className={className}
      width="13"
      height="16"
      viewBox="0 0 13 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M0 1.45455C0 0.651222 0.6467 0 1.44444 0H11.5556C12.3533 0 13 0.651229 13 1.45455V14.5455C13 15.3488 12.3533 16 11.5556 16H1.44444C0.646707 16 0 15.3488 0 14.5455V1.45455ZM11.5556 1.45455H1.44444V9.45455H11.5556V1.45455ZM11.5556 10.9091H1.44444V14.5455H11.5556V10.9091ZM5.05556 12.7273C5.05556 12.3256 5.37891 12 5.77778 12H7.22222C7.62109 12 7.94444 12.3256 7.94444 12.7273C7.94444 13.1289 7.62109 13.4545 7.22222 13.4545H5.77778C5.37891 13.4545 5.05556 13.1289 5.05556 12.7273Z"
        fill="#E75909"
      />
    </svg>
  );
};

export default SmartPhone;
